export const viewBoxFrequencyPageEvent = available_options => ({
  type: 'View box frequency selection page',
  data: {
    available_options,
  },
});
